import { lazy } from 'react';

// Entrypoints. Have to be in this file due to how chunks are formed
export const SignUp = lazy(() => import('./signup/SignUp'));
export const Layout = lazy(() => import('src/layout/Layout'));
export const Public = lazy(() => import('src/public/Public'));
export const Login = lazy(() => import('src/public/Login/LoginEntry'));
export const CompanyDisabled = lazy(() => import('src/public/CompanyDisabled/CompanyDisabledPage'));

// Settings page components
export const InvoicingForm = lazy(() => import('./settings/Invoicing/InvoicingForm'));
export const OffersForm = lazy(() => import('./settings/Offers/OffersForm'));
export const NotificationsForm = lazy(() => import('./settings/Notifications/NotificationsForm'));
export const IntegrationView = lazy(() => import('./settings/Integration/IntegrationView'));
export const MomentIntegrationsView = lazy(() => import('./settings/MomentIntegrations/MomentIntegrationsView'));
export const GeneralForm = lazy(() => import('./settings/General/GeneralForm'));
export const EmployeesForm = lazy(() => import('./settings/Employees/EmployeesForm'));
export const MyselfSettings = lazy(() => import('./settings/myself/MyselfSettings'));
export const ProjectsForm = lazy(() => import('./settings/Projects/ProjectSetupSettingView/ProjectsForm'));
export const QualitySettings = lazy(() => import('./settings/quality/QualitySettings'));
export const TextsView = lazy(() => import('./settings/Texts/TextsView'));
export const TranslationsView = lazy(() => import('./settings/Texts/translations/TranslationsView'));
export const ExportTemplatesView = lazy(() => import('./settings/ExportTemplates/ExportTemplatesView'));
export const HourlyRates = lazy(() => import('./settings/priceList/HourlyRates/HourlyRates'));
export const ProductPriceList = lazy(() => import('./settings/priceList/ProductPriceList/ProductPriceList'));
export const NewPriceListHourlyRates = lazy(() => import('./settings/priceList/actionBtn/NewPriceListHourlyRates'));
export const NewPriceListProduct = lazy(() => import('./settings/priceList/actionBtn/NewPriceListProduct'));
export const ServiceMessagesView = lazy(() => import('./settings/ServiceMessages/ServiceMessagesView'));
export const CustomFieldsSetup = lazy(() => import('./settings/customFieldsSetup/CustomFieldsSetup'));
export const GeneralTagsSetupView = lazy(() => import('./settings/tagsSetup/GeneralTagsSetupView'));
export const NotificationTemplatesView = lazy(() => import('./settings/NotificationTemplates/NotificationTemplatesView'));
export const UserRoutePreferencesView = lazy(() => import('./settings/RoutePreferences/UserRoutePreferencesView'));
export const CompanyRoutePreferencesView = lazy(() => import('./settings/RoutePreferences/CompanyRoutePreferencesView'));
export const ScheduledTasksView = lazy(() => import('./settings/ScheduledTasks/ScheduledTasksView'));
export const CompanyContactsReportView = lazy(() => import('./settings/CompanyContactsReport/CompanyContactsReportView'));
export const CalendarImportView = lazy(() => import('./settings/myself/components/CalendarImportView'));
export const ApiAccessView = lazy(() => import('./company/ApiAccessView'));
export const IPaasSettingsView = lazy(() => import('./settings/IPaas/IPaasSettings'));
export const AccessControlView = lazy(() => import('./settings/accessControl/AccessControlView'));
export const AccessControlContainerUpdate = lazy(() => import('./settings/accessControl/AccessControlContainerUpdate'));
export const AccessControlContainerNew = lazy(() => import('./settings/accessControl/AccessControlContainerNew'));
export const NewServiceMessageAction = lazy(() => import('./settings/ServiceMessages/components/NewServiceMessageAction'));
export const CustomerPlanList = lazy(() => import('./customerPlan/CustomerPlan'));


// My pages components
export const NotificationsOverview = lazy(() => import('./myself/Notifications/NotificationsOverview'));
export const ProjectCardOverview = lazy(() => import('./myself/ProjectCardOverview'));

// Travel and expense
export const ClaimList = lazy(() => import('./travelExpense/Claims/ClaimList'));
export const ClaimForm = lazy(() => import('./travelExpense/Claim/ClaimForm'));
export const TravelExpenseInbox = lazy(() => import('./travelExpense/Inbox/TravelExpenseInbox'));

// Project page components
export const ProjectFilesPage = lazy(() => import('./projects/FilesView/ProjectFilesPage'));
export const AvailabilityView = lazy(() => import('./projects/AvailabilityView/ResourcePlannerWrapper'));
export const InfolandProducts = lazy(() => import('./projects/Ambita/InfolandProducts'));
export const ActivitiesView = lazy(() => import('./projects/ActivitiesView/ActivitiesView'));
export const QualitySystemCompetency = lazy(() => import('./projects/competency/QualitySystemCompetencyView'));
export const ReviewsView = lazy(() => import('./projects/reviews/ReviewsView'));
export const NonconformityView = lazy(() => import('./projects/NonconformityView/NonconformityView'));
export const ProjectsTimelineView = lazy(() => import('./projects/timeline/projectsTimelineView/ProjectsTimelineView'));
export const ProjectsMileStonesView = lazy(() => import('./projects/timeline/projectsMileStonesView/ProjectsMileStonesView'));
export const AccrualReportView = lazy(() => import('./projects/accrualReportView/AccrualReportView'));
export const ProjectDocumentView = lazy(() => import('./projects/ProjectDocument/ProjectDocumentView'));
export const PrintableTimeRecord = lazy(() => import('./projects/timeRecord/printableTimeRecord/PrintableTimeRecord'));
export const ProjectInvoiceSettingView = lazy(() => import('./settings/Projects/ProjectInvoiceSettingView'));
export const ProjectBudgetView = lazy(() => import('./projects/BudgetView/BudgetView'));
export const ProjectMainPage = lazy(() => import('./projects/MainPage/ProjectMainPage'));
export const CustomerPriceListsView = lazy(() => import('./customers/PriceListsPage/CustomerPriceListsView'));
export const ActivitiesReportView = lazy(() => import('./projects/ActivitiesReport/ActivitiesReportView'));
export const ProjectsCardsView = lazy(() => import('./projects/cardsView/ProjectsCardsView'));
export const ProjectManagerDashboard = lazy(() => import('./projects/pm-dashboard/ProjectManagerDashboard'));
// export const ProjectGanttView = lazy(() => import('./projects/Gantt/GanttView'));  // temporarily disabled until we have a proper Gantt chart lisence

// Quality page components
export const RiskAssessmentView = lazy(() => import('./qualitySystem/riskAssessmentView/RiskAssessmentView'));
export const RiskManagementView = lazy(() => import('./qualitySystem/riskManagementView/RiskManagementView'));
export const RiskReportView = lazy(() => import('./qualitySystem/risk/RiskReport/RiskReportView'));
export const RoutinesView = lazy(() => import('./qualitySystem/routines/RoutinesView'));
export const ProjectReviewsView = lazy(() => import('./qualitySystem/projectReviewsView/ProjectReviewsView'));
export const NonconformitiesTemplatesView = lazy(() => import('./qualitySystem/nonconformitiesTemplates/NonconformitiesTemplatesView'));
export const QualitySystemView = lazy(() => import('./qualitySystem/checklists/QualitySystemView'));
export const ChecklistForm = lazy(() => import('src/components/qualitySystem/checklists/ChecklistForm/ChecklistForm'));
export const TasksOverviewView = lazy(() => import('./qualitySystem/tasksOverviewView/TasksOverviewView'));
export const TaskMainPage = lazy(() => import('./tasks/MainPage/TaskMainPage'));
export const ChecklistReportView = lazy(() => import('./qualitySystem/checklists/ChecklistReport/ChecklistReportView'));

// Checklist page components
export const ChecklistProjectView = lazy(() => import('./checklist/ChecklistProjectView/ChecklistProjectView'));
export const ChecklistDetailsView = lazy(() => import('./checklist/ChecklistDetailsView/ChecklistDetailsView'));


// Tasks
export const TaskEditorInjection = lazy(() => import('./tasks/TaskEditorInjection'));
export const TaskHeaderAction = lazy(() => import('./tasks/TaskHeaderAction'));

// Overviews page components
export const ProjectsOverviewView = lazy(() => import('./overviews/ProjectsOverviewView'));
export const UsersOverviewView = lazy(() => import('./overviews/UsersOverviewView'));
export const CustomersOverviewView = lazy(() => import('./overviews/CustomersOverviewView'));
export const ContactsOverviewPage = lazy(() => import('./customers/ContactsOverviewPage/ContactsOverviewPage'));
export const CustomerInvoiceSettingView = lazy(() => import('./settings/customer/CustomerInvoiceSettingView/CustomerInvoiceSettingView'));
export const ProjectsListOverviewView = lazy(() => (import('src/pages/overviews/ProjectsListOverviewView')));

// Contact pages
export const ContactDetailsPage = lazy(() => import('./customers/ContactsOverviewPage/ContactDetailsPage'));
export const ContactsReportView = lazy(() => import('./customers/ContactsReportPage/ContactsReportView'));

// User pages
export const HrView = lazy(() => import('./users/hr/HrView'));
export const HourlyRatesView = lazy(() => import('./users/preferences/HourlyRatesView/HourlyRatesView'));
export const AbsenceOverview = lazy(() => import('./resources/AbsenceOverview/AbsenceOverview'));
export const TimeBalance = lazy(() => import('./resources/TimeBalance/TimeBalance'));
export const CapacityView = lazy(() => import('./users/capacity/CapacityView'));

// Company page components
export const HolidaysView = lazy(() => import('./company/HolidaysView/HolidaysView'));
export const CompanyHierarchy = lazy(() => import('./company/CompanyHierarchy'));
export const CompanyBudgetView = lazy(() => import('./company/CompanyBudgetView'));
export const BudgetView = lazy(() => import('./company/budget/BudgetView'));
export const SignaturesView = lazy(() => import('./company/SignaturesView'));

// Other page components
export const UsersPerformanceView = lazy(() => import('./company/usersPerformance/UsersPerformanceView'));
export const NotificationsView = lazy(() => import('./users/preferences/NotificationsView/NotificationsView'));

// Education fund page components
export const ContinuesEducationAccrualSetup = lazy(() => import('./settings/EmployeesDevelopment/AccrualSetup/ContinuesEducationAccrualSetup'));
export const MyEducationFundsOverview = lazy(() => import('./company/employeesEducation/employeesEducationOverview/MyEducationFunds'));
export const EducationFundsOverview = lazy(() => import('./company/employeesEducation/employeesEducationOverview/EducationFunds'));
export const EducationOverview = lazy(() => import('./company/educationOverview/EducationOverview'));

// Invoices
export const InvoiceLinesReportView = lazy(() => import('./invoices/invoiceLines/InvoiceLinesReportView'));

// Analytics
export const AnalyticsEmbedded = lazy(() => import('./analytics/AnalyticsEmbedded'));
export const AnalyticsSales = lazy(() => import('./analytics/AnalyticsSales'));
export const AnalyticsTenants = lazy(() => import('./analytics/AnalyticsTenants'));
export const AnalyticsTenant = lazy(() => import('./analytics/AnalyticsTenant'));

export const AbsenceCalendar = lazy(() => import('./company/absenceCalendar/AbsenceCalendar'));

export const PageSunset = lazy(() => import('./errorView/components/pageSunset/PageSunset'));

